// extracted by mini-css-extract-plugin
export default {"requiredStar":"RequiredStar_requiredStar__B6wsH"};